export function parseUserAgent(ua = "") {
    let browser = "Unknown Browser";
    let os = "Unknown OS";

    if (/Windows NT/i.test(ua)) os = "Windows";
    else if (/Macintosh|Mac OS X/i.test(ua)) os = "macOS";
    else if (/Android/i.test(ua)) os = "Android";
    else if (/iPhone|iPad/i.test(ua)) os = "iOS";
    else if (/Linux/i.test(ua)) os = "Linux";

    const edgeMatch = ua.match(/Edg\/([\d]+)/);
    const chromeMatch = ua.match(/Chrome\/([\d]+)/);
    const firefoxMatch = ua.match(/Firefox\/([\d]+)/);
    const safariMatch = ua.match(/Safari\/([\d]+)/);

    if (edgeMatch) browser = `Edge ${edgeMatch[1]}`;
    else if (chromeMatch) browser = `Chrome ${chromeMatch[1]}`;
    else if (firefoxMatch) browser = `Firefox ${firefoxMatch[1]}`;
    else if (safariMatch) browser = `Safari ${safariMatch[1]}`;

    return `${browser} on ${os}`;
}